export default __webpack_public_path__ + "static/media/Group 3226@2x.bb1cb293.png";